// extracted by mini-css-extract-plugin
module.exports = {"whole":"AboutMe_whole__15RNF","box":"AboutMe_box__2f_Ri","heading":"AboutMe_heading__gBAOl","paragraphs":"AboutMe_paragraphs__Wl2qy","myImage":"AboutMe_myImage__38zA6"};